import { useLocalStorage } from '@rehooks/local-storage';
export var useLocalStorageToggle = function (key, defaultValue) {
    var _a = useLocalStorage(key, defaultValue), storedBoolean = _a[0], writeStorage = _a[1];
    var toggleValue = function () {
        writeStorage(!storedBoolean);
    };
    return [storedBoolean, toggleValue];
};
